import { Box, Button, Center, Stack, Table, Tbody, Td, Text, Th, Thead, Tr, List, ListItem, ListIcon } from "@chakra-ui/react"
import { MdOutlineCircle } from "react-icons/md"
import { useDispatch } from 'react-redux'
import { deleteLayer, editLayer } from "../../features/creator/creatorSlice"
import { useState } from "react"

import LayerForm from "./LayerForm"
import EditModal from "../ui/EditModal"

export default function LayerList({ map }) {

    const dispatch = useDispatch()

    const [layerToEdit, setLayerToEdit] = useState()

    const deleteButtonHandler = (layerId) => {
        dispatch(deleteLayer({
            mapId: map._id,
            layerId: layerId,
        }))
    }

    const formatPosition = (position) => `${position.lat.toFixed(3)}, ${position.lon.toFixed(3)}`

    const formatMarker = (marker) => (
        <List>
            <ListItem><ListIcon as={MdOutlineCircle} boxSize="14px" /><Text as="span">Variant: {marker.variant}</Text></ListItem>
            <ListItem><ListIcon as={MdOutlineCircle} boxSize="14px" /><Text as="span">Size: {marker.size}</Text></ListItem>
            <ListItem><ListIcon as={MdOutlineCircle} boxSize="14px" /><Text as="span">Position: ({formatPosition(marker.position)})</Text></ListItem>
        </List>
    )

    const formatLine = (line) => (
        <List>
            <ListItem>Color: <Text as="span" fontWeight="semibold">{line.color}</Text></ListItem>
            <ListItem>Variant: <Text as="span" fontWeight="semibold">{line.variant}</Text></ListItem>
            <ListItem>
                Start Marker: {line.startMarker ? formatMarker(line.startMarker) : <Text color="gray.800">None</Text>}
            </ListItem>
            <ListItem>
                End Marker: {line.endMarker ? formatMarker(line.endMarker) : <Text color="gray.800">None</Text>}
            </ListItem>
        </List>
    )

    const layerType = (layer) => {
        if (layer.marker) return 'Marker'
        if (layer.line) return 'Line'
        return 'Unknown'
    }

    return (
        <>
            {map.layers.length > 0 ? (
                <Table variant="simple">
                    <Thead>
                        <Tr>
                            <Th>Description</Th>
                            <Th>Styling</Th>
                            <Th>Actions</Th>
                        </Tr>
                    </Thead>
                    <Tbody>
                        {map.layers.map((layer) => (
                            <Tr key={layer._id}>
                                <Td>
                                    <Text>{layer.description}</Text>
                                    <Text as="span" color="gray.600" fontSize="sm">
                                        ({layerType(layer)})
                                    </Text>
                                </Td>
                                <Td>
                                    <Stack spacing={3}>
                                        {layer.marker && formatMarker(layer.marker)}
                                        {layer.line && formatLine(layer.line)}
                                    </Stack>
                                </Td>
                                <Td>
                                    <Button colorScheme="blue" size="sm" mr={1} onClick={() => setLayerToEdit(layer)}>Edit</Button>
                                    <Button colorScheme="red" size="sm" onClick={() => deleteButtonHandler(layer._id)}>Delete</Button>
                                </Td>
                            </Tr>
                        ))}
                    </Tbody>
                </Table>
            ) : (
                <Center paddingY={4}>
                    <Text fontSize='lg'>No layers to display.</Text>
                </Center>
            )}

            {layerToEdit && 
                <EditModal 
                    itemToEdit={layerToEdit}
                    headingText='Edit layer'
                >
                    <LayerForm 
                        mapBeingEdited={map}
                        editPrefilledLayer={layerToEdit} 
                    />
                </EditModal>
            }
        </>
    )
}